import { render, staticRenderFns } from "./hero-promo.vue?vue&type=template&id=d8dda6cc&scoped=true&"
import script from "./hero-promo.vue?vue&type=script&lang=js&"
export * from "./hero-promo.vue?vue&type=script&lang=js&"
import style0 from "./hero-promo.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./hero-promo.vue?vue&type=style&index=1&id=d8dda6cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8dda6cc",
  null
  
)

export default component.exports